import produce from "immer";
import { LoadState } from "../../../constants/enums";
import {
  IGLSummaryReconcileState,
  initialGLSummaryReconcileState,
} from "./GLSummaryReconcile.types";
import { GLSummaryReconcileActions } from ".";
import {
  CLEAR_GL_SUMMARY_RECONCILE_STATE,
  DETECT_HISTORIC_FAILED,
  DETECT_HISTORIC_PROGRESS,
  DETECT_HISTORIC_SUCCESS,
  FETCH_RECONCILE_FAILED,
  FETCH_RECONCILE_PROGRESS,
  FETCH_RECONCILE_SUCCESS,
  REBUILD_SNAPSHOT_FAILED,
  REBUILD_SNAPSHOT_PROGRESS,
  REBUILD_SNAPSHOT_SUCCESS,
  RUN_BACKFILL_RUNBOOK_FAILED,
  RUN_BACKFILL_RUNBOOK_PROGRESS,
  RUN_BACKFILL_RUNBOOK_SUCCESS,
  RUN_NIGHTLY_RECONCILE_FAILED,
  RUN_NIGHTLY_RECONCILE_PROGRESS,
  RUN_NIGHTLY_RECONCILE_SUCCESS,
  VALIDATE_FISCAL_CALENDAR_FAILED,
  VALIDATE_FISCAL_CALENDAR_PROGRESS,
  VALIDATE_FISCAL_CALENDAR_SUCCESS,
} from "./GLSummaryReconcileActions";

export const glSummaryReconcileReducer = (
  state: IGLSummaryReconcileState = initialGLSummaryReconcileState,
  action: GLSummaryReconcileActions
) => {
  switch (action.type) {
    // ========================================================================
    // Reconcile (GET)
    // ========================================================================
    case FETCH_RECONCILE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.reconcileLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_RECONCILE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.reconcileLoading = LoadState.Loaded;
        draftState.reconcile = data;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_RECONCILE_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.reconcileLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Rebuild snapshot (POST)
    // ========================================================================
    case REBUILD_SNAPSHOT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.rebuildLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case REBUILD_SNAPSHOT_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.rebuildLoading = LoadState.Loaded;
        draftState.error = null;
      });
      return newState;
    }

    case REBUILD_SNAPSHOT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.rebuildLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Nightly reconcile (POST)
    // ========================================================================
    case RUN_NIGHTLY_RECONCILE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.nightlyReconcileLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case RUN_NIGHTLY_RECONCILE_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.nightlyReconcileLoading = LoadState.Loaded;
        draftState.error = null;
      });
      return newState;
    }

    case RUN_NIGHTLY_RECONCILE_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.nightlyReconcileLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Validate fiscal calendar (GET)
    // ========================================================================
    case VALIDATE_FISCAL_CALENDAR_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.calendarValidationLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case VALIDATE_FISCAL_CALENDAR_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.calendarValidationLoading = LoadState.Loaded;
        draftState.error = null;
      });
      return newState;
    }

    case VALIDATE_FISCAL_CALENDAR_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.calendarValidationLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Detect historic RE entries (POST)
    // ========================================================================
    case DETECT_HISTORIC_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.historicDetectionLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case DETECT_HISTORIC_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.historicDetectionLoading = LoadState.Loaded;
        draftState.error = null;
      });
      return newState;
    }

    case DETECT_HISTORIC_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.historicDetectionLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Backfill runbook (POST)
    // ========================================================================
    case RUN_BACKFILL_RUNBOOK_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.backfillRunbookLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case RUN_BACKFILL_RUNBOOK_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.backfillRunbookLoading = LoadState.Loaded;
        draftState.error = null;
      });
      return newState;
    }

    case RUN_BACKFILL_RUNBOOK_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.backfillRunbookLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Clear
    // ========================================================================
    case CLEAR_GL_SUMMARY_RECONCILE_STATE: {
      return initialGLSummaryReconcileState;
    }

    default:
      return state;
  }
};
